import { Routes, Route, Navigate } from 'react-router-dom';

import { AuthProvider } from './api/AuthProvider';
import Login from './react/pages/Login';
import Register from './react/pages/Register';
import Feed from './react/pages/Feed';
import Profile from './react/pages/Profile';
import Boards from './react/pages/Boards';
import MacroAnalysis from './react/pages/MacroAnalysis';
import Portfolio from './react/pages/Portfolio';
import { PrivateRoute, PublicRoute } from './react/utils/RouteWrapper';

import './scss/style.scss';

const App = () => {
    return (
        <div className="App">
            <AuthProvider>
                <Routes>
                    <Route path="/" element={<Navigate to="/feed" />} />
                    <Route
                        path="/register"
                        element={
                            <PublicRoute>
                                <Register />
                            </PublicRoute>
                        }
                    />
                    <Route
                        path="/login"
                        element={
                            <PublicRoute>
                                <Login />
                            </PublicRoute>
                        }
                    />
                    <Route
                        path="/feed"
                        element={
                            <PrivateRoute>
                                <Feed />
                            </PrivateRoute>
                        }
                    />
                    <Route path="/profile" element={<Navigate to="/feed" />} />
                    <Route
                        path="/profile/:username"
                        element={
                            <PrivateRoute>
                                <Profile />
                            </PrivateRoute>
                        }
                    />
                    <Route
                        path="/boards"
                        element={
                            <PrivateRoute>
                                <Boards />
                            </PrivateRoute>
                        }
                    />
                    <Route
                        path="/macro"
                        element={
                            <PrivateRoute>
                                <MacroAnalysis />
                            </PrivateRoute>
                        }
                    />
                    <Route
                        path="/portfolio"
                        element={
                            <PrivateRoute>
                                <Portfolio />
                            </PrivateRoute>
                        }
                    />
                </Routes>
            </AuthProvider>
        </div>
    );
};

export default App;
